// angular基本
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//  自訂組件
import { TranfPipe } from './pipe/tranf.pipe';
import { IsInvaildPipe } from './pipe/is-invaild.pipe';
import { IsExistPipe } from './pipe/is-exist.pipe';
import { KeywordPipe } from './pipe/keyword.pipe';
import { InputFormatDirective } from './directive/input-email.directive';
import { CalendarComponent } from './component/calendar/calendar.component';
import { SelectProductComponent } from './component/select-product/select-product.component';
import { EditAttachComponent } from './component/edit-attach/edit-attach.component';
import { SelectStoreComponent } from './component/select-store/select-store.component';
import { EditProductComponent } from './component/edit-product/edit-product.component';
import { EditEOSProductComponent } from './component/edit-EOS-product/edit-EOS-product.component';
import { EditAttachgroupComponent } from './component/edit-attachgroup/edit-attachgroup.component';
import { SelectattachgroupComponent } from './component/select-attachgroup/select-attachgroup.component';
import { SelectAttachComponent } from './component/select-attach/select-attach.component';
import { SelectSalesOutletComponent } from './component/select-salesOutlet/select-salesOutlet.component';
import { SelectStoreSaleCashComponent } from './component/select-storeSaleCash/select-storeSaleCash.component';
import { ShowDataComponent } from './component/show-data/show-data.component';
import { SelectMemberTypeComponent } from './component/select-memberType/select-memberType.component';
import { EditAnnouncementComponent } from './component/edit-announcement/edit-announcement.component';
import { SelectAttachPrintComponent } from './component/select-attach-print/select-attach-print.component';
import { SelectStoresComponent } from './component/select-stores/select-stores.component';
import { ReportReconciliationComponent } from './component/report-reconciliation/report-reconciliation.component';
import { SelectBillmachineMoudleComponent } from './component/select-billmachine-moudle/select-billmachine-moudle.component'
import { SelectStoreButtonAuthComponent } from './component/select-store-button-auth/select-store-button-auth.component';
import { SelectStoreOpsettingComponent } from './component/select-store-opsetting/select-store-opsetting.component';
import { SelectMenuProductComponent } from './component/select-menu-product/select-menu-product.component';
import { SearchMenuProductComponent } from './component/search-menu-product/search-menu-product.component';
import { SearchMenuAttachComponent } from './component/search-menu-attach/search-menu-attach.component';

import { MyPieComponent } from './chart/my-pie.component';
import { MyLineComponent } from './chart/my-line.component';
import { MyPointComponent } from './chart/my-point.component';



// 框架的畫面組件
import { ThemeModule } from '../@theme/theme.module';
import {
  NbCardModule,
  NbIconModule,
  NbButtonModule,
  NbCheckboxModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbToggleModule,
  NbTreeGridModule,
  NbTimepickerModule,
  NbDatepickerModule,
  NbAutocompleteModule,
  NbMenuModule,
  NbSpinnerModule,

} from '@nebular/theme';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxEchartsModule } from 'ngx-echarts';
import { SelectAttachMoudleComponent } from './component/select-attach-moudle/select-attach-moudle.component';
import { SelectPermissionsgroupComponent } from './component/select-permissionsgroup/select-permissionsgroup.component';
import { InfoOrdComponent } from './component/info-ord/info-ord.component';
import { AutoSelectComponent } from './object/auto-select/auto-select.component';
import { MyBarComponent } from './chart/my-bar.component';
import { InfoEOSOrdComponent } from './component/info-EOS-ord/info-EOS-ord.component';
import { InfoEOSDetailComponent } from './component/info-EOS-detail/info-EOS-detail.component';
import { StatusUpdateModalComponent } from './component/status-update-modal/status-update-modal.component';


@NgModule({
  imports: [
    NgxDropzoneModule,
    FormsModule,   //用於對表單元素做雙向係結
    ReactiveFormsModule, //對表單元素驗證用
    CommonModule,
    ThemeModule,
    NbSpinnerModule,

    NbMenuModule,
    NbCardModule,
    NbIconModule,
    NbButtonModule,
    NbCheckboxModule,
    NbInputModule,
    NbRadioModule,
    NbSelectModule,
    NbToggleModule,
    NbTreeGridModule,
    NbTimepickerModule,
    NbDatepickerModule,
    NbAutocompleteModule,
    NgxEchartsModule],
  declarations: [
    TranfPipe,
    IsInvaildPipe,
    IsExistPipe,
    KeywordPipe,
    InputFormatDirective,
    CalendarComponent,
    SelectProductComponent,
    EditAttachComponent,
    SelectStoreComponent,
    EditProductComponent,
    EditEOSProductComponent,
    EditAttachgroupComponent,
    SelectattachgroupComponent,
    SelectAttachComponent,
    SelectSalesOutletComponent,
    SelectStoreSaleCashComponent,
    MyPieComponent,
    MyLineComponent,
    MyPointComponent,
    SelectAttachMoudleComponent,
    SelectPermissionsgroupComponent,
    InfoOrdComponent,
    AutoSelectComponent,
    MyBarComponent,
    InfoEOSOrdComponent,
    InfoEOSDetailComponent,
    StatusUpdateModalComponent,
    ShowDataComponent,
    SelectMemberTypeComponent,
    EditAnnouncementComponent,
    SelectAttachPrintComponent,
    SelectStoresComponent,
    ReportReconciliationComponent,
    SelectBillmachineMoudleComponent,
    SelectStoreButtonAuthComponent,
    SelectStoreOpsettingComponent,
    SelectMenuProductComponent,
    SearchMenuProductComponent,
    SearchMenuAttachComponent
  ],
  exports: [
    TranfPipe,
    IsInvaildPipe,
    IsExistPipe,
    KeywordPipe,
    InputFormatDirective,
    CalendarComponent,
    SelectProductComponent,
    EditAttachComponent,
    SelectStoreComponent,
    EditProductComponent,
    EditEOSProductComponent,
    EditAttachgroupComponent,
    SelectattachgroupComponent,
    SelectAttachComponent,
    SelectAttachMoudleComponent,
    SelectPermissionsgroupComponent,
    MyPieComponent,
    MyLineComponent,
    MyPointComponent,
    MyBarComponent,
    InfoOrdComponent,
    AutoSelectComponent,
    InfoEOSOrdComponent,
    InfoEOSDetailComponent,
    StatusUpdateModalComponent,
    ShowDataComponent,
    SelectMemberTypeComponent,
    EditAnnouncementComponent,
    SelectAttachPrintComponent,
    SelectStoresComponent,
    ReportReconciliationComponent,
    SelectBillmachineMoudleComponent,
    SelectStoreButtonAuthComponent,
    SelectStoreOpsettingComponent,
    SelectMenuProductComponent,
    SearchMenuProductComponent,
    SearchMenuAttachComponent
  ],
  providers: [

  ]
})

export class ToolModule {

  static forRoot() {
    return {
      ngModule: ToolModule,
      providers: [],
    };
  }
} 